

import { useState } from "react"
import { Box, CssBaseline } from "@mui/material"
import TopBar from "./TopBar"
import Sidebar from "./Sidebar"
import { useAuth } from "../../contexts/AuthContext"

const DRAWER_WIDTH = 280

function DashboardLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false)
  const { user } = useAuth()

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <TopBar onMenuClick={handleDrawerToggle} />
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={handleDrawerToggle}
        drawerWidth={DRAWER_WIDTH}
        userRole={user?.role}
        className="bg-amber-800"
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` },
          mt: 8, // Account for AppBar height
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default DashboardLayout
